"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContentReveal = function ContentReveal(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      revealAxis = _ref.revealAxis,
      applyFadeEffect = _ref.applyFadeEffect,
      animationCloseDuration = _ref.animationCloseDuration,
      animationOpenDuration = _ref.animationOpenDuration,
      animationFadeInDuration = _ref.animationFadeInDuration,
      animationFadeOutDuration = _ref.animationFadeOutDuration,
      keepContentInDom = _ref.keepContentInDom,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "visible", "revealAxis", "applyFadeEffect", "animationCloseDuration", "animationOpenDuration", "animationFadeInDuration", "animationFadeOutDuration", "keepContentInDom"]);

  var container = (0, _react.useRef)();
  var parentContainer = (0, _react.useRef)();

  var _useState = (0, _react.useState)(visible ? 'auto' : '0px'),
      currentDimension = _useState[0],
      setCurrentDimension = _useState[1];

  var _useState2 = (0, _react.useState)(visible ? 'auto' : '0px'),
      stageDimension = _useState2[0],
      setStageDimension = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isAnimating = _useState3[0],
      setIsAnimating = _useState3[1];

  var _useState4 = (0, _react.useState)(visible),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  (0, _react.useLayoutEffect)(function () {
    var findDimension = function findDimension() {
      if (revealAxis === 'x') {
        var parentWidth = parentContainer.current.scrollWidth;
        var _componentWidth = container.current.scrollWidth;
        return parentWidth > 0 ? parentWidth : _componentWidth;
      }

      var componentWidth = container.current.scrollHeight;
      return componentWidth;
    };

    var animateSliderOpen = function animateSliderOpen() {
      var dimension = findDimension();
      setStageDimension(dimension + "px");
      setCurrentDimension("0px");
      setIsAnimating(true);
      requestAnimationFrame(function () {
        setCurrentDimension(dimension + "px");
        setIsOpen(true);
        setTimeout(function () {
          setIsAnimating(false);
          setStageDimension('auto');
          setCurrentDimension('auto');
        }, animationOpenDuration);
      });
    };

    var animateSliderClosed = function animateSliderClosed() {
      var dimension = findDimension();
      setStageDimension(dimension + "px");
      setCurrentDimension(dimension + "px");
      setIsAnimating(true);
      requestAnimationFrame(function () {
        setIsOpen(false);
        setCurrentDimension('0px');
        setTimeout(function () {
          setStageDimension('auto');
          setIsAnimating(false);
        }, animationCloseDuration);
      });
    };

    if (!isOpen && visible && !isAnimating) {
      requestAnimationFrame(function () {
        animateSliderOpen();
      });
    } else if (isOpen && !visible && !isAnimating) {
      requestAnimationFrame(function () {
        animateSliderClosed();
      });
    }
  }, [animationCloseDuration, animationOpenDuration, isOpen, visible, currentDimension, revealAxis, isAnimating]);
  return (0, _themeUi.jsx)("div", _extends({
    ref: parentContainer
  }, props), (0, _themeUi.jsx)("div", {
    sx: {
      height: revealAxis === 'y' ? currentDimension : 'auto',
      width: revealAxis === 'x' ? currentDimension : 'auto',
      position: 'relative',
      overflow: 'hidden',
      transitionProperty: 'width, height',
      transitionDuration: isOpen ? animationOpenDuration + "ms" : animationCloseDuration + "ms",
      transitionTimingFunction: function transitionTimingFunction(theme) {
        return theme.easing.standard;
      }
    }
  }, (keepContentInDom || visible || isAnimating || isOpen) && (0, _themeUi.jsx)("div", {
    ref: container,
    sx: _extends({
      height: revealAxis === 'y' ? stageDimension : 'auto',
      width: revealAxis === 'x' ? stageDimension : 'auto',
      overflow: 'auto'
    }, applyFadeEffect && {
      opacity: isOpen ? 1 : 0,
      transitionProperty: 'opacity',
      transitionDuration: isOpen ? animationFadeInDuration + "ms" : animationFadeOutDuration + "ms",
      transitionTimingFunction: function transitionTimingFunction(theme) {
        return theme.easing.standard;
      }
    })
  }, children)));
};

ContentReveal.propTypes = {
  children: _propTypes["default"].node.isRequired,
  applyFadeEffect: _propTypes["default"].bool,
  visible: _propTypes["default"].bool,
  animationOpenDuration: _propTypes["default"].number,
  animationCloseDuration: _propTypes["default"].number,
  animationFadeInDuration: _propTypes["default"].number,
  animationFadeOutDuration: _propTypes["default"].number,
  revealAxis: _propTypes["default"].oneOf(['y', 'x']),
  keepContentInDom: _propTypes["default"].bool
};
ContentReveal.defaultProps = {
  applyFadeEffect: true,
  visible: false,
  animationOpenDuration: 300,
  animationCloseDuration: 250,
  animationFadeInDuration: 250,
  animationFadeOutDuration: 200,
  revealAxis: 'y',
  keepContentInDom: false
};
var _default = ContentReveal;
exports["default"] = _default;